var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _rect2, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 94,
    viewBox: "0 0 109 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 64,
    height: 64,
    rx: 4,
    fill: "#E9FFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 18C38 15.2386 40.2386 13 43 13C45.7614 13 48 15.2386 48 18C48 20.7614 45.7614 23 43 23C40.2386 23 38 20.7614 38 18Z",
    fill: "#0E4C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 36C23 33.2386 25.2386 31 28 31C30.7614 31 33 33.2386 33 36C33 38.7614 30.7614 41 28 41C25.2386 41 23 38.7614 23 36Z",
    fill: "#0E4C54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 54C15 51.2386 17.2386 49 20 49C22.7614 49 25 51.2386 25 54C25 56.7614 22.7614 59 20 59C17.2386 59 15 56.7614 15 54Z",
    fill: "#0E4C54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H34",
    stroke: "#0E4C54",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 36H19",
    stroke: "#0E4C54",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 54H20",
    stroke: "#0E4C54",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43 18L60 18",
    stroke: "#0E4C54",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36L60 36",
    stroke: "#0E4C54",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54L60 54",
    stroke: "#0E4C54",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.2073,
    cy: 52.5,
    r: 22.4204,
    transform: "rotate(-45 64.2073 52.5)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.1126,
    cy: 49.2852,
    r: 20,
    transform: "rotate(-45 64.1126 49.2852)",
    fill: "#6EE4D9",
    stroke: "#0E4C54",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.0329,
    y: 75.4492,
    width: 6,
    height: 22,
    rx: 2,
    transform: "rotate(-45 86.0329 75.4492)",
    fill: "#0E4C54",
    stroke: "#0E4C54",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1542 73.3253L78.2547 63.4258",
    stroke: "#0E4C54",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 68H8C5.79086 68 4 66.2091 4 64V8C4 5.79086 5.79086 4 8 4H36H64C66.2091 4 68 5.79086 68 8V21.5",
    stroke: "#0E4C54",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilter);
export default __webpack_public_path__ + "static/media/search-filter.6d8b97720a967ac9be93157f44d18455.svg";
export { ForwardRef as ReactComponent };